import { render } from "./TagFilters.vue?vue&type=template&id=079d393b"
import script from "./TagFilters.vue?vue&type=script&lang=js"
export * from "./TagFilters.vue?vue&type=script&lang=js"

import "./TagFilters.vue?vue&type=style&index=0&id=079d393b&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__